import { baseElementSchema } from "@/Components/Exercises/Elements/base";
import {
    numberReturnOpSchema,
    stringArrayReturnOpSchema,
    stringReturnOpSchema,
} from "@/Components/Exercises/LogicOperation";
import { z } from "zod";

export const orderedChoiceElementSchema = baseElementSchema.extend({
    type: z.literal("orderedChoice"),
    question: z.union([z.string(), stringReturnOpSchema]),
    options: z.union([
        stringArrayReturnOpSchema,
        z.array(z.union([z.string(), stringReturnOpSchema])),

        // Old schema. Don't use this anymore. We can now pass the array of strings directly.
        z.object({
            logicOp: stringArrayReturnOpSchema,
        }),
    ]),
    numberOfChoices: z.union([z.number().min(1), numberReturnOpSchema]),
});
export const orderedChoiceElementDataSchema = z.object({
    orderedAnswers: z.array(z.string()),
});
export type OrderedChoiceElement = z.infer<typeof orderedChoiceElementSchema>;
export type OrderedChoiceElementData = z.infer<
    typeof orderedChoiceElementDataSchema
>;
